/* eslint-disable react/prop-types */
import Tooltip from "@shared/v2/Tooltip";

const cellSizeDictionary = {
  small: "tw-h-[24px] tw-w-[24px]",
  medium: "tw-h-[36px] tw-w-[36px]",
  large: "tw-h-[48px] tw-w-[48px]",
};

const imageSizeDictionary = {
  small: "tw-h-[20px]",
  medium: "tw-h-[30px]",
  large: "tw-h-[40px]",
};

const initialsFontDictionary = {
  small: "tw-text-12d tw-font-semibold",
  medium: "tw-text-14d tw-font-semibold",
  large: "tw-text-18d",
};

const InitialsCircle = ({ initials, size = "large", className = "" }) => (
  <span
    className={`tw-inline-flex tw-shrink-0 tw-items-center tw-justify-center tw-bg-gray-light ${cellSizeDictionary[size]} tw-rounded-full ${className}`}
  >
    {initials}
  </span>
);

const AgentCell = ({ agent, size = "large", showName = false }) => {
  const { photoURL, name, showURL } = agent;
  const hasImage = !!photoURL;
  const hasProfileLink = !!showURL;

  const imageClasses = showName
    ? `${cellSizeDictionary[size]} tw-object-cover`
    : `tw-my-[4px] ${imageSizeDictionary[size]}`;

  const avatar = hasImage ? (
    <img className={`tw-shrink-0 tw-rounded-full ${imageClasses}`} src={photoURL} alt={name} />
  ) : (
    <InitialsCircle
      initials={agent.initials}
      size={size}
      className={showName ? initialsFontDictionary[size] : ""}
    />
  );

  const content = showName ? (
    <>
      {avatar}
      <span className="tw-text-14d tw-font-semibold tw-truncate">{name}</span>
    </>
  ) : (
    <Tooltip trigger={avatar} content={name} />
  );

  const layout = showName ? "tw-justify-start" : `tw-justify-center ${cellSizeDictionary[size]}`;
  const inner = `tw-py-4px tw-flex tw-items-center tw-overflow-hidden ${showName ? "tw-gap-[14px]" : ""}`;

  return (
    <div className={`tw-flex tw-flex-row tw-items-center tw-flex-nowrap ${layout}`}>
      {hasProfileLink ? (
        <a className={inner} href={showURL}>
          {content}
        </a>
      ) : (
        <div className={`${inner} tw-select-none`}>{content}</div>
      )}
    </div>
  );
};

export default AgentCell;
